import React, { useCallback, useEffect, useRef, useState } from "react";

const NACSA_END = new Date("2026-10-30T00:00:00-04:00");
const ALL = [
  { h: "Know your school's health.", t: "A research-based MySchoolRx diagnostic across 8 pillars.", c: "See how it works", u: "/how-it-works" },
  { h: "115 indicators. One clear picture.", t: "Turn your school's data into a board-ready risk report.", c: "Explore the diagnostic", u: "/myschoolrx" },
  { h: "See every school in your portfolio.", t: "Compare schools side by side, banded Healthy, Caution or High Risk.", c: "Learn about Portfolio", u: "/how-it-works" },
  { h: "Meet Ron at NACSA · Oct 27–29", t: "Stop by for a walkthrough of MySchoolRx.", c: "Become a Founding Partner", u: "/myschoolrx/pilot", until: NACSA_END },
];

const reducedMotion = () => typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

// Right-side marketing message: only the text rotates (5 s crossfade) over a static gradient.
export const LoginCarousel = () => {
  const slides = ALL.filter((s) => !s.until || new Date() < s.until);
  const rm = reducedMotion();
  const [i, setI] = useState(0);
  const [fade, setFade] = useState(false);
  const [paused, setPaused] = useState(rm);
  const [hover, setHover] = useState(false);
  const [live, setLive] = useState("off");
  const timer = useRef(null);

  const show = useCallback((k) => {
    if (rm) { setI(k); return; }
    setFade(true);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => { setI(k); setFade(false); }, 500);
  }, [rm]);

  useEffect(() => {
    const id = setInterval(() => {
      if (!paused && !hover && !document.hidden && !rm) { setLive("off"); show((i + 1) % slides.length); }
    }, 5000);
    return () => clearInterval(id);
  }, [i, paused, hover, rm, show, slides.length]);
  useEffect(() => () => clearTimeout(timer.current), []);

  const s = slides[i];
  return (
    <section className="copy" aria-roledescription="carousel" aria-label="About MySchoolRx" data-testid="login-carousel"
      onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}
      onFocus={() => setHover(true)} onBlur={() => setHover(false)}>
      <div className={`live${fade ? " fade" : ""}`} aria-live={live} data-testid="login-carousel-slide">
        <h2 data-testid="login-carousel-headline">{s.h}</h2>
        <p>{s.t}</p>
        <a href={s.u} data-testid="login-carousel-cta">{s.c} →</a>
      </div>
      <div className="ctrl">
        <span className="sr">Choose slide</span>
        <span>
          {slides.map((_, k) => (
            <button key={k} type="button" className="dot" aria-label={`Slide ${k + 1} of ${slides.length}`} aria-current={k === i}
              style={{ marginRight: 4 }} data-testid={`login-carousel-dot-${k}`}
              onClick={() => { setLive("polite"); show(k); }} />
          ))}
        </span>
        <button type="button" className="pause" aria-pressed={paused} onClick={() => setPaused((p) => !p)} data-testid="login-carousel-pause">
          {paused ? "Play" : "Pause"}
        </button>
      </div>
    </section>
  );
};

export default LoginCarousel;
